import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import {
  AffectedStaff,
  AffectedStaffMap
} from '../../lib/types/models/affectedStaff/affected-staff'
import { AffectedStaffFilters } from '../../lib/types/models/affectedStaff/affected-staff-input'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getAffectedStaffs(
  input?: PaginationRequest<AffectedStaffFilters>
): Promise<PaginationResponse<AffectedStaff>>

export function getAffectedStaffs<T extends keyof AffectedStaffMap>(
  input: PaginationRequest<AffectedStaffFilters>,
  version: T
): Promise<PaginationResponse<AffectedStaffMap[T]>>

export function getAffectedStaffs<T extends keyof AffectedStaffMap>(
  input: PaginationRequest<AffectedStaffFilters> = {},
  version?: T
) {
  return restApiClient
    .url(encodeNestedObject(API.affectedStaffs.getAll.url, { ...input, version }))
    .get<
      PaginationResponse<T extends keyof AffectedStaffMap ? AffectedStaffMap[T] : AffectedStaff>
    >()
}
